'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UIButtonGroup from 'UIComponents/button/UIButtonGroup';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';

const StorefrontViewToggle = ({
  activeView,
  onChange
}) => {
  return /*#__PURE__*/_jsxs(UIButtonGroup, {
    className: "p-right-4",
    children: [/*#__PURE__*/_jsx(UIIconButton, {
      active: activeView === 'list',
      "data-test-id": "storefront-list-view-button",
      onClick: () => {
        onChange('list');
      },
      use: "tertiary-light",
      size: "small",
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "listView"
      })
    }), /*#__PURE__*/_jsx(UIIconButton, {
      active: activeView === 'grid',
      onClick: () => {
        onChange('grid');
      },
      use: "tertiary-light",
      size: "small",
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "grid",
        size: "small"
      })
    })]
  });
};

StorefrontViewToggle.Proptypes = {
  activeView: PropTypes.oneOf(['grid', 'list']).isRequired,
  onChange: PropTypes.func.isRequired
};
export default StorefrontViewToggle;